import { defaultProducto } from "./state";

export function cargarEstados(state, estados) {

    state.estados = [];

    for (var i = 0; i < estados.length; i++) {
        state.estados.push({ value: estados[i].id, text: estados[i].lista });
    }

}

export function CargarExisteNoExiste(state, control_existe) {

    state.control_existe = [];

    for (var i = 0; i < control_existe.length; i++) {
        state.control_existe.push({ value: control_existe[i].id, text: control_existe[i].lista });
    }

}

export function resetFiltro(state) {
    state.filtro.empresa = "",
    state.filtro.nombre = "",
    state.filtro.sinonimos = "",
    state.filtro.proveedorfabricante = "",
    state.filtro.confecha = [],
    state.filtro.base = "",
    state.filtro.area = "",
    state.filtro.area = "",
    state.filtro.campoPersonalizado = "",
    state.filtro.valorcampo = "",
    state.filtro.campo = "",
    state.filtro.page = 1,
    state.filtro.perPage = 10,
    state.filtro.sortBy = 'id',
    state.filtro.sort = 'DESC'
    //state.filtro.contratista = ''
}


export function setProductos(state, productos) {
  state.productos = [];
}

export function productError(state, error) {
    state.error = error;
}

export function setFiltro(state, buscar) {
    state.filtro = buscar
}
export function setListaEmpresa(state, empresas) {
    state.empresas = empresas
}
export function setListaBases(state, bases) {
    state.bases = bases
}
export function setListaAreas(state, areas) {
    state.areas = areas
}
export function setListaCampos(state, campos) {
    state.campos = campos
}

export function setFiltroBases(state, bases) {
    state.filtro.base = bases;
}
export function setFiltroAreas(state, areas) {
    state.filtro.area = areas;
}

export function setAccion(state, accion) {
    state.accion = accion;
}
/* export function resetSelectedProduct(state) {
    Object.assign(state.selectedProduct, defaultProducto())
} */

export function limpiarProducto(state) {
    state.selectedProduct = {
        id: '',
        activo: 1,
        verificado: 0,
        nombre: '',
        sinonimos: '',
        componentesactivos: '',
        componentesactivosIngles: '',
        cas: '',
        estado: '',
        proveedorfabricante: '',
        uso: '',
        observacion: '',
        disposiciontratamiento: '',
        doc_sga: '',
        doc_etiqueta: '',
        fecha_etiqueta: '',
    }
}

export function setComponente(state, componente) {
    state.selectedProduct.componentesactivos = componente /* Object.assign(componente) */
}

export function setPage(state, page) {
    state.filtro.page = page
}
export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso
}
export function setPermisosEmpresa(state, permiso) {
    state.esEmpresa = permiso
}


export function asignaEmpresa(state, id_empresa) {
    state.filtro.empresa = id_empresa;
}

/**
 * Mutación que carga la información de campos personalizados de la pantalla de empresas.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} campos contiene la información de campos personalizados.
 */
export function setCamposPersonalizados(state, campos) {
    state.camposPersonalizados = campos;
}

export function setBasesAreas(state, datos) {

    var basesareas = [];
    var bases = [];
    var areas = [];
    var combinacion1 = [];
    var combinacion2 = [];




    /* var newObjeto = []

    datos.forEach(element => {

        newObjeto[element.base_desc] ? // check if that array exists or not in newObjeto object
            newObjeto[element.base_desc].Push({ base: element.base_desc, area: element.area_desc }) // just Push
            :
            (newObjeto[element.base_desc] = [], newObjeto[element.base_desc].Push({ base: element.base_desc, area: element.area_desc })) // create a new array and Push

    });

     */

    var result = [];
    var result2 = [];
    var result3 = [];

    /* var result = datos.reduce((h, element) => Object.assign(h, {
        [element.base_desc]: (h[element.base_desc] || []).concat({ area: element.area_desc })
    }), {}) */






    //bases y areas
    datos.forEach(element => {
        //if (element.base_desc != "" && element.area_desc != "") {
        basesareas.push(element);
        //}
    });

    result = basesareas.reduce((h, element) => Object.assign(h, {
        [element.base_desc]: (h[element.base_desc] || []).concat({ area: element.area_desc })
    }), {})


    //solo bases
    /* datos.forEach(element => {
        if (element.base_desc != "" && element.area_desc == "") {
            bases.push(element);
        }
    });

    result2 = bases.reduce((h, element) => Object.assign(h, {
        [element.base_desc]: (h[element.base_desc] || []).concat({ area: element.area_desc })
    }), {}) */


    //combinacion3 = result2.concat(result);
   


    //solo areas
    /* datos.forEach(element => {
        if (element.base_desc == "" && element.area_desc != "") {
            areas.push(element);
        }
    });

    result3 = areas.reduce((h, element) => Object.assign(h, {
        [element.base_desc]: (h[element.base_desc] || []).concat({ area: element.area_desc })
    }), {}) */


    /* combinacion1 = basesareas.concat(bases);
    combinacion2 = combinacion1.concat(areas); */

    state.list_basesareas = result;
}

/**
 * Método que carga la infromación de Cas de la generales.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} data contiene la información de cas de la generales.
 */
export function setCasEmpresa(state, data) {

    state.tlvs = []
    state.iarcs = []
    state.otos = []
    state.neuros = []
    state.scs = []
    state.bios = []
    state.repros = []
    state.mutas = []
    state.teras = []


    data.Cas.forEach(i => {
        if (i.tipo == "Tlv") { //TLV
            state.tlvs.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Iarc") { //Iarc
            state.iarcs.push(
                i.datos.datos
            );

        }
        if (i.tipo == "Sustancias_controladas") { //SC
            state.scs.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Neurotoxicos") { //Neurotoxicos
            state.neuros.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Ototoxicos") { //Ototoxicos
            state.otos.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Biopersistentes") { //Biopersistentes
            state.bios.push(
                i.datos.datos
            );
        }

        if (i.tipo == "Mutagenicos") { //Mutagenicos
            state.mutas.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Teratogenicos") { //Teratogenicos
            state.teras.push(
                i.datos.datos
            );
        }
        if (i.tipo == "Reprotoxicos") { //Reprotoxicos
            state.repros.push(
                i.datos.datos
            );
        }

    })

    state.list_basesareas = datos;
}

/**
 * Mutación para limpiar las bases y areas de la vista generales.
 *
 * @param {*} state
 */
export function limpiaBasesAreasEmpresa(state) {
    state.list_basesareas = [];

}


/**
 * Mutación para asignarle la generales al filtro para contratista
 *
 * @param {*} state
 * @param int Id de la generales a asingar
 */
export function asignaEmpresaYusuario(state, datos) {
    state.filtro.contratista = datos.edicionUsuario.id;
    state.filtro.empresa = datos.selectedEmpresa.id;
}
